import { FORM_VALIDATOR_TYPES } from '../constants';
import { SyllabusFormValues } from '../interface/syllabus.interface';

export enum FREQUENCY_TYPE {
  DAILY = 'DAILY',
  WEEKLY = 'WEEKLY',
  MONTHLY = 'MONTHLY',
  QUARTERLY = 'QUARTERLY',
  SEMI = 'SEMI',
  ANNUAL = 'ANNUAL',
}

export enum SYLLABUS_STATUS {
  DELETED = 'DELETED',
}

export const typeOptions = [
  { label: FREQUENCY_TYPE.DAILY, value: FREQUENCY_TYPE.DAILY },
  { label: FREQUENCY_TYPE.WEEKLY, value: FREQUENCY_TYPE.WEEKLY },
  { label: FREQUENCY_TYPE.MONTHLY, value: FREQUENCY_TYPE.MONTHLY },
  { label: FREQUENCY_TYPE.QUARTERLY, value: FREQUENCY_TYPE.QUARTERLY },
  { label: FREQUENCY_TYPE.SEMI, value: FREQUENCY_TYPE.SEMI },
  { label: FREQUENCY_TYPE.ANNUAL, value: FREQUENCY_TYPE.ANNUAL },
];

export const SYLLABUS_FORM_INIT: SyllabusFormValues = {
  curriculum: {
    value: undefined,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  grade: {
    value: undefined,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  subject: {
    value: undefined,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  description: {
    value: '',
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
  type: {
    value: undefined,
    isRequired: true,
    error: null,
    validator: FORM_VALIDATOR_TYPES.TEXT,
    disable: false,
  },
};
